module.exports = __webpack_public_path__ + "img/FormatBrushIcon.aadfbbb4.svg";